import React, { useCallback } from 'react';
import { Button } from '@mui/material';
import { trackClickedSubscribeCTA } from '@surfline/web-common';
import WavetrakLink from '../WavetrakLink';
import Styles from './MultiCamPaywall.module.scss';

interface Props {
  href?: string;
  segmentProperties: {
    location: string;
    category: string;
    pageName: string;
    subregionId?: string;
    spotId?: string;
    spotName?: string;
  };
}

const MultiCamPaywall: React.FC<Props> = ({ href = '/upgrade', segmentProperties }) => {
  const onClickPaywall = useCallback(() => {
    trackClickedSubscribeCTA(segmentProperties);
  }, [segmentProperties]);

  return (
    <div className="sl-multi-cam-paywall" data-testid="multi-cam-paywall">
      <div className="sl-multi-cam-paywall__content">
        <h1 className="sl-multi-cam-paywall__title">Multi-Cam is a Premium Only Feature.</h1>
        <div className="sl-multi-cam-paywall__subtitle-container">
          <span className="sl-multi-cam-paywall__subtitle">
            View multiple camera angles at the same time.
          </span>
        </div>
        <WavetrakLink
          className={Styles.ctaWavetrakLink}
          href={href}
          isExternal
          onClick={onClickPaywall}
        >
          <Button className={Styles.ctaButton} variant="primary">
            Upgrade
          </Button>
        </WavetrakLink>
        <WavetrakLink
          className="sl-multi-cam-paywall__learn-more"
          href="https://support.surfline.com/hc/en-us/articles/200933315-What-are-the-benefits-of-being-a-Premium-subscriber"
          isExternal
        >
          Learn more about Surfline Premium
        </WavetrakLink>
      </div>
    </div>
  );
};

export default MultiCamPaywall;
